module.exports = __webpack_public_path__ + "media/icons/section_b-9c29c421.png";